module.exports = __webpack_public_path__ + "media/images/vp/icon.camera.white-c382fa8534001d4b70ba8daa83a9250d.svg";